var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('avue-empty',{staticClass:"pad-tb-40",attrs:{"image":_vm.img,"desc":_vm.msg}}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }